"use client";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import paymentsHistoryClient from '../../../utility/apiClients/account/paymentsHistoryClient';
import Storage from '../../../utility/features/helpers/storageHelper';
import "../../../styles/myAccount/myAccount.module.css";
import paymentStyles from '../../../styles/myAccount/payment.module.css';

function RecentPayments({ labels }) {
  const [showData, setShowData] = useState(false);
  const [years, setYears] = useState([]);
  const [paymentsGroupedByYear, setPaymentsGroupedByYear] = useState({});
  const [selectedYear, setSelectedYear] = useState('');
  const [sortBy, setSortBy] = useState('date');
  const [sortDesc, setSortDesc] = useState(true);
  const customerNumber  = localStorage.getItem("customerNumbers") ? JSON.parse(localStorage.getItem("customerNumbers"))[0] : "7006223876";
  const recentPaymentsDesc = labels.rpDesc ? labels.rpDesc + customerNumber : '';

  // Sort compare function
  const sortCompareByType = (type) => {
    return (a, b) => {
      if (type === 'date') {
        return new Date(a.date) - new Date(b.date);
      } else if (type === 'amount') {
        return a.amount - b.amount;
      } else if (type === 'type') {
        return (a.type || '').localeCompare(b.type || '');
      } else if (type === 'ref') {
        return (a.ref || '').localeCompare(b.ref || '');
      }
      return 0;
    };
  };

  useEffect(() => {
    paymentsHistoryClient(customerNumber).then(
      response => {
        setYears(response.years);
        setPaymentsGroupedByYear(response.paymentsGroupedByYear);
        setSelectedYear(response.years && response.years.length > 0?response.years[0] : '');
        setShowData(true);
      },
      error => {}
    );
  }, [customerNumber]);

  const handleSort = (value) => {
    if (value === sortBy) {
      setSortDesc(!sortDesc);
    } else {
      setSortBy(value);
    }
  };

  const handleChangeYear = (e) => {
    setSelectedYear(e.target.value);
  };

  let payments = (selectedYear != ''?paymentsGroupedByYear[selectedYear] : []).sort(sortCompareByType(sortBy));
  if (!sortDesc) {
    payments = payments.reverse();
  }
  return (
    <>
      <div>
        <div
          className={`${paymentStyles["bg-gray-100"]} mb-md-40  ${paymentStyles["p-20"]} ${paymentStyles["tru-mma-main-wrapper"]} ${paymentStyles["payment-section"]} tru-mma-mobile-margins tru-mma-recent-payments`}
        >
          <div className="container-fluid">
            <div className="row mb-20">
              <div className="col-12 col-md-9 col-lg-10 mb-3 mb-md-0">
                <span
                  className={`d-block ${paymentStyles["gfs-24"]} ${paymentStyles["gfw-3"]} g-line `}
                >
                  {labels.recentPayments}
                </span>
                <span className={`${paymentStyles["gfs-14"]} ${paymentStyles["gfw-3"]} ${paymentStyles["lh-1-2"]}`}>{recentPaymentsDesc}</span>
              </div>
              <div className="col-12 col-md-3 col-lg-2">
                <label htmlFor="recentPaymentSelect" className="sr-only">
                  {labels.paymentYear}
                </label>
                <div className="tru-mma-select">
                  <select
                    id="recentPaymentSelect"
                    className={`form-select ${paymentStyles["recent-payment-option"]}`}
                    onChange={handleChangeYear}
                    value={selectedYear}
                  >
                    {years && years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div
              className={`col-12 d-none d-md-block ${paymentStyles["sucesspayment-table-pd-top"]}`}
            >
              <table
                className={`table table-borderless  ${paymentStyles["sucesspayment-table-bg-color"]}`}
              >
                <thead className='text-decoration-underline'>
                  <tr>
                    <TableHeader
                      type="date"
                      onClick={handleSort}
                      label={labels.date}
                      sortBy={sortBy}
                      sortDesc={sortDesc}
                    />
                    <TableHeader
                      type="type"
                      onClick={handleSort}
                      label={labels.paymentType}
                      sortBy={sortBy}
                      sortDesc={sortDesc}
                    />
                    <TableHeader
                      type="ref"
                      onClick={handleSort}
                      label={labels.paymentRef}
                      sortBy={sortBy}
                      sortDesc={sortDesc}
                    />
                    <TableHeader
                      type="amount"
                      onClick={handleSort}
                      label={labels.amount}
                      sortBy={sortBy}
                      sortDesc={sortDesc}
                    />
                  </tr>
                </thead>
                <tbody className={`${paymentStyles["gfw-3"]}`}>
                  {showData && payments.length === 0 && (
                    <tr>{labels.noPayment}</tr>
                  )}
                  {showData &&
                    payments.length > 0 &&
                    payments.map((payment, i) => (
                      <tr key={`${selectedYear}-${i}`}>
                        <td className="pb-2">{payment.formattedDate}</td>
                        <td className="pb-2">{payment.type}</td>
                        <td className="pb-2">{payment.ref}</td>
                        <td className="pb-2">
                          {payment.symbol}
                          {payment.amountBase}
                          <sup>{payment.amountDec}</sup>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className={`${paymentStyles["bg-white"]} d-md-none ${paymentStyles["py-30"]} tru-mma-mobile-margins`}>
          <div className="container-fluid">
            <div className="d-md-none row">
              <div className={`col-12 ${paymentStyles["mob-mlr-0"]}`}>
                {showData &&
                  payments.length > 0 &&
                  payments.map((payment, i) => (
                    <div
                      className={`${paymentStyles["bg-gray-100"]} g-line-height-1_2 ${paymentStyles["p-10"]} ${paymentStyles["tru-mma-main-collapse-box"]}`}
                      key={`${selectedYear}-${i}`}
                    >
                      <div>
                        <span className={`${paymentStyles["g-font-weight-700"]}`}>
                          {labels.date}:
                        </span>{" "}
                        <span>{payment.formattedDate}</span>
                      </div>
                      <div>
                        <span className={`${paymentStyles["g-font-weight-700"]}`}>
                          {labels.paymentType}:
                        </span>{" "}
                        <span>{payment.type}</span>
                      </div>
                      <div>
                        <span className={`${paymentStyles["g-font-weight-700"]}`}>
                          {labels.paymentRef}:
                        </span>{" "}
                        <span>{payment.ref}</span>
                      </div>
                      <div>
                        <span className={`${paymentStyles["g-font-weight-700"]}`}>
                          {labels.amount}:
                        </span>{" "}
                        <span>
                          {payment.symbol}
                          {payment.amountBase}
                          <sup>{payment.amountDec}</sup>
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
    
RecentPayments.propTypes = {
  data: PropTypes.any,
  labels: PropTypes.object.isRequired
};
      
function TableHeader({type, label, sortBy, onClick, sortDesc}) {
  var className = '';
  if (sortBy === type) {
    className = sortDesc ? 'icon-chevron-down' : 'icon-chevron-up';
  }
  return (
    <th scope='col'
      onClick={() => onClick(type)}
      className={`${paymentStyles["gfw-4"]} g-text-underline p-0`}>
      <a onClick={() => onClick(type)}>{label}</a> <span className={className} />
    </th>
  );
}
      
TableHeader.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  sortBy: PropTypes.string,
  sortDesc: PropTypes.bool,
  onClick: PropTypes.func,
};
      
export default RecentPayments;